import { Outlet, useParams } from 'react-router-dom'

import { EmployeeGroupRootPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useQuery } from 'modules/core/hooks/useQuery'

const EmployeeGroupRootPage = () => {
  const { employee_group_id } = useParams()
  const employeeGroupId = String(employee_group_id)

  const { data: employeeGroupsData, loading } = useQuery(EmployeeGroupRootPageDocument, {
    variables: {
      id: employeeGroupId,
    },
    skip: !employeeGroupId,
  })

  const employeeGroup = employeeGroupsData?.employees.employeeGroup

  if (loading) return null

  if (!employeeGroup) return <NotFound />

  return <Outlet context={{ employeeGroup }} />
}

export default EmployeeGroupRootPage
